import { render } from "./FilesGlossaryDialogs.vue?vue&type=template&id=e1983bb0"
import script from "./FilesGlossaryDialogs.vue?vue&type=script&lang=js"
export * from "./FilesGlossaryDialogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__